export const styles = {
  infiniteScroll: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    maxHeight: '400px',
    overflow: 'auto',
    height: 'auto',
    paddingTop: '20px',
    marginBottom: '24px',
    '&::-webkit-scrollbar': {
      border: 'none',
      width: '11px',
      height: '11px',
      padding: '5px 0',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fff',
      border: 'none',
      height: '10px',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
      cursor: 'pointer',
    },
  },
};
